import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Wine, Loader2, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F5F5F4] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#57534E] hover:text-[#1C1917] mb-6" data-testid="back-home-link">
          <ArrowLeft className="h-4 w-4" /> Back to site
        </Link>
        <div className="bg-white rounded-2xl shadow-sm border border-[#E7E5E4] p-8 md:p-10">
          <div className="flex items-center gap-3 mb-8">
            <div className="h-11 w-11 rounded-full bg-[#4A5D23]/10 flex items-center justify-center">
              <Wine className="h-6 w-6 text-[#4A5D23]" />
            </div>
            <div>
              <h1 className="font-serif text-2xl text-[#1C1917]">Staff Login</h1>
              <p className="text-sm text-[#57534E]">Gledswood Cellar Door</p>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5" data-testid="admin-login-form">
            <div>
              <label className="block text-sm font-semibold mb-2 text-[#1C1917]">Email</label>
              <input
                type="email"
                required
                data-testid="login-email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@gledswood.com"
                className="w-full px-4 py-3 rounded-xl border border-[#E7E5E4] bg-white focus:ring-2 focus:ring-[#4A5D23]/20 focus:border-[#4A5D23] transition-colors outline-none"
              />
            </div>
            <div>
              <label className="block text-sm font-semibold mb-2 text-[#1C1917]">Password</label>
              <input
                type="password"
                required
                data-testid="login-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="w-full px-4 py-3 rounded-xl border border-[#E7E5E4] bg-white focus:ring-2 focus:ring-[#4A5D23]/20 focus:border-[#4A5D23] transition-colors outline-none"
              />
            </div>

            {error && (
              <p data-testid="login-error" className="text-sm text-red-600 bg-red-50 rounded-lg px-3 py-2">
                {error}
              </p>
            )}

            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit-btn"
              className="w-full py-3.5 px-8 bg-[#4A5D23] text-white rounded-full font-semibold hover:bg-[#3D4D1D] transition-all flex items-center justify-center gap-2 disabled:opacity-60"
            >
              {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
